export default (date) => {
    const fields = date.split("/");

    const dd = fields[0];
    const mm = fields[1];
    const yy = fields[2];
    return yy + "/" + mm + "/" + dd;
};